import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Data.Controller.EXPO_NumericalDBExt = (function(){

    var Cache = WRAP.Cache;
    var tile_data_size = 256*256*4+256;
    var request = [];
    var loading = [];

    function getCache(key) {
//console.log("get cache:"+key);        
        var cached = Cache.get(key);
        return cached && cached.data;
    }

    function getError(key) {
        var cached = Cache.get(key);
        return cached && cached.error;
    }

    function setCache(key, data, size, ds, error) {
        Cache.set(key, data, size, ds, error);
    }

    function checkError(res, urls, data) {
        if ( res.status ) {
            var text = "EXPO NumericalDB error:"+JSON.stringify(res);
            var url = urls&&(Array.isArray(urls)?urls[0]:urls);
            WRAP.Loader.error(url, data, WRAP.Data.Status.EXPO_DATA_ERROR, text);
            console.error(text);
            return true;
        }
        if (!Array.isArray(res) && Object.keys(res).length === 0) {
            return true;
        }
    }

    function makeTileKey(ds, option, tile_id, sampling) {
        var tile_key = ds.makeDataKey(option, ds.data.controller_conf.data);
        tile_key += "/"+tile_id;
        if ( sampling )
            tile_key += "/"+sampling;
        return tile_key;
    }    

    function maxTileZoom(grid) {
        var y_tile = 0;
        var x_tile = 0;
        var yt = grid.TileSize, xt = grid.TileSize;
        while ( yt < grid.Height ) {
            yt *= 2;
            y_tile++;
        }
        while ( xt < grid.Width ) {
            xt *= 2;
            x_tile++;
        }
        return (y_tile>x_tile)?y_tile:x_tile;
    }
    
    function extract(option, tile) {
        var options = [];
        
        var elements = (option.element&&Array.isArray(option.element))?option.element.length:0;
        if ( elements ) {
            for ( var i = 0 ; i < elements ; i++ ) {
                var opt = {};
                for ( var key in option ) {
                    var v = option[key];
                    if ( key == 'element' )
                        v = option[key][i];
                    opt[key] = v;
                }
                if ( tile ) {
                    for ( var key in tile ) {
                        opt[key] = tile[key];
                    }
                }
                options.push({option:opt, index:i});
            }
        }
        else {
            var opt = {};
            for ( var key in option ) {
                for ( var key in option ) {
                    opt[key] = option[key];
                }
            }
            if ( tile ) {
                for ( var key in tile ) {
                    opt[key] = tile[key];
                }
            }
            options.push({option:opt, index:0});
        }
        return options;
    }

    function addData(wait, source, desc, tile) {
        var extracted = extract(source.option, tile);
        for ( var i = 0 ; i < extracted.length ; i++ ) {
            var ex = extracted[i];
            var data_key = source.ds.makeDataKey(ex.option, source.ds.data.controller_conf.data); 
            var element = ex.option.element;
            var db_element = element;
            var alias = source.ds.conf.alias && source.ds.conf.alias.element && source.ds.conf.alias.element[element];
            if ( alias )
                db_element = alias;
            var minValue, maxValue, noValue;
            var def = source.ds.data.control.element[db_element];
            if ( def ) {
                minValue = def.MIN_VALUE;
                maxValue = def.MAX_VALUE;
                noValue = def.NO_VALUE;
            }
            var override = source.grid.element && source.grid.element[element];
            if ( override ) {
                if ( override.MinValue )
                    minValue = override.MinValue;
                if ( override.MaxValue )
                    maxValue = override.MaxValue;
            }
            var cached_data = getCache(data_key);
            var data_desc = {};
            for ( var key in desc )
                data_desc[key] = desc[key];
            data_desc.ds = source.ds;
            data_desc.option = ex.option;
            data_desc.index = ex.index;
            data_desc.element = extracted.length;
            data_desc.minValue = minValue;
            data_desc.maxValue = maxValue;
            data_desc.noValue = noValue;
            data_desc.key = data_key;
            data_desc.data = cached_data;
            source.data_list.push(data_desc);
            if ( !data_desc.data )
                wait.push(data_desc);
        }
    }

    function makeArray(array, width, height, lack) {
        var data = new Float32Array(array);
        var count = width*height;
        var values = new Float32Array(count);
        if ( !isNaN(lack) ) {
            for (var i = 0 ; i < count ; i++ ) {
                var v = data[i];
                if ( v == lack )
                    values[i] = NaN;
                else
                    values[i] = v;
            }
        }
        else {
            for (var i = 0 ; i < count ; i++ )
                values[i] = data[i];
        }
        return values;
    }

    function load(data_desc) {
        if ( data_desc.data )
            return;
        if ( loading[data_desc.key] )
            return;
        loading[data_desc.key] = true;
//console.log("load:"+data_desc.key);        
//console.log("load:"+JSON.stringify(data_desc.option));        
        data_desc.ds.load(data_desc.option, false,
            function(data, urls) {
                var size = (data_desc.width * data_desc.height)*4;
                size /= (data_desc.option.dx * data_desc.option.dy); 
                if ( data.byteLength < size ) {
                    var text = "EXPO rawdata error";
                    if ( data.byteLength < 1000 )
                        text += ":"+String.fromCharCode.apply("", new Uint8Array(data));
                    WRAP.Loader.error(urls[0], JSON.stringify(data_desc.option), WRAP.Data.Status.EXPO_DATA_ERROR, text);
                    setCache(data_desc.key, [], 256, data_desc.ds, {url:urls[0], status:WRAP.Data.Status.EXPO_DATA_ERROR});
                }
                else {
                    var values = makeArray(data, data_desc.width, data_desc.height, data_desc.noValue);
                    setCache(data_desc.key, values, size+256, data_desc.ds);
                }
                updateRequest();
                delete loading[data_desc.key];
            },
            function(data, url, status) {
                setCache(data_desc.key, [], 256, data_desc.ds, {url:url, status:status});
                updateRequest();
                delete loading[data_desc.key];
            }
        );
    }

    function updateRequest() {
        var r = [].concat(request);
        for ( var i = 0 ; i < r.length ; i++ )
            processRequest(r[i])
    }

    function processRequest(r) {
        return processGPV(r);
    }

    var Band = function(size, wrap_around, partial) {
        if ( !wrap_around )
            size--;
        this.seg = [];
        this._wrap_around = wrap_around;

        this._regist = function(s, e) {
            if ( e < 0 || size < s )
                return;
            if ( s < 0 )
                s = 0;
            if ( size < e )
                e = size;
            if ( e < s )
                return;
            for ( var i = 0 ; i < this.seg.length ; i++ ) {
                var t = this.seg[i];
                if ( t.e < s )
                    continue;                               // check next
                if ( e < t.s ) {
                    this.seg.splice(i, 0, {s:s, e:e});      // insert
                    return;
                }
                else {
                    if ( s < t.s ) 
                        t.s = s;                                // ovewrap->expand s
                    if ( t.e < e )
                        t.e = e;                                // ovewrap->expand e
                    return;
                }
            }
            this.seg.push({s:s, e:e});
        }

        this.add = function(s, e) {
            if ( this._wrap_around ) {
                this._regist(s, e);
                if ( s < 0 )
                    this._regist(s+this._wrap_around, e+this._wrap_around);
                if ( e > size )
                    this._regist(s-this._wrap_around, e-this._wrap_around);
            }
            else {
                this._regist(s, e);
            }
        }

        //　return [origin, size]
        this.get = function() {
            var l = this.seg.length;
            if ( l ) {
                var s, e;
                if ( !partial && wrap_around && l > 1 && this.seg[0].s == 0 && this.seg[l-1].e == size ) {
                    var min = 0, pos = -1;
                    for ( var i = 1 ; i < l ; i++ ) {
                        var diff = this.seg[i].s - this.seg[i-1].e;
                        if ( min < diff ) {
                            min = diff;
                            pos = i;
                        }
                    }
                    if ( pos < 0 ) {
                        s = 0;
                        e = size;
                    }
                    else {
                        s = this.seg[pos].s;
                        e = this.seg[pos-1].e+size;
                    }
                }
                else {
                    s = this.seg[0].s;
                    e = this.seg[l-1].e;
                }
                return [s, e-s];
            }
        }
    }

    function processGPV(r) {
        var tiled;
        var error_gpv = {};
        for ( var s = 0 ; s < r.source.length ; s++ ) {
            var source = r.source[s];
            tiled = source.tiled;
            var data_list = source.data_list;
            for ( var i = 0 ; i < data_list.length ; i++ ) {
                var data_desc = data_list[i];
                if ( !data_desc.data ) {
                    var data = getCache(data_desc.key);
                    if ( !data )
                        return;
                    data_desc.data = data;
                }
                var error = getError(data_desc.key);
                if ( error )
                    error_gpv[data_desc.key] = error;
            }
        }

        var grid = r.grid;
        var step = r.step;
        var wrap_around = r.wrap_around?Math.round(360/grid.LonInterval):0;
        var y_band = new Band(grid.Height);
        var x_band = new Band(grid.Width, wrap_around, (grid.LonInterval*grid.Width<359));
        for ( var s = 0 ; s < r.source.length ; s++ ) {
            var g = r.source[s].range;
            y_band.add(g.sy, g.ey);
            x_band.add(g.sx, g.ex);
        }
        var y_range = y_band.get();
        var x_range = x_band.get();
        var w, h, gpv;
        if ( !y_range || !x_range ) {
            var gpv = {
                lonBase: grid.LonBase,
                latBase: grid.LatBase,
                lonInterval: grid.LonInterval*step,
                latInterval: grid.LatInterval*step,
                width:0,
                height:0,
                data:new Float32Array(0),
                lonIntervalSource: grid.LonInterval,
                latIntervalSource: grid.LatInterval
            }
        }
        else {
            var sx = 0;
            var sy = 0;

            if ( step > 1 ) {
                // adjust decimation to global edge
                if ( !tiled ) {
                    var ax = Math.round(grid.LonBase/grid.LonInterval)%step;
                    if ( ax ) {
                        sx = (step-ax);
                        x_range[0] += sx;
                        x_range[1] -= sx;            
                    }
                    var ay = Math.round((90-grid.LatBase)/grid.LatInterval)%step;
                    if ( ay ) {
                        sy = (step-ay);
                        y_range[0] += sy;
                        y_range[1] -= sy;            
                    }
                }
            }
            
            var w = Math.floor(x_range[1]/step)+1;
            if ( w*grid.LonInterval*step > 360 )
                w = Math.floor(360/(grid.LonInterval*step));
            var h = Math.floor(y_range[1]/step)+1;
            var size = w*h;
            var gpv = {
                lonBase: grid.LonBase+x_range[0]*grid.LonInterval,
                latBase: grid.LatBase-y_range[0]*grid.LatInterval,
                lonInterval: grid.LonInterval*step,
                latInterval: grid.LatInterval*step,
                width:w,
                height:h,
                lonIntervalSource: grid.LonInterval,
                latIntervalSource: grid.LatInterval
            }
            var wrap_sample = Math.ceil(Math.round(360/grid.LonInterval)/step);
            // check wrap around gap
            if ( r.wrap_around && grid.Width%step && (x_range[0]+x_range[1]) >= grid.Width )  {
                gpv.gap = Math.floor((grid.Width-x_range[0])/step);
                gpv.gapBase = grid.LonBase;
            }
            var arrayed = r.element && Array.isArray(r.element);
            if ( arrayed ) {
                gpv.data = [];
                for ( var e = 0 ; e < r.element.length ; e++ ) {
                    gpv.data[e] = new Float32Array(size);
                    gpv.data[e].fill(NaN)
                }
            }
            else {
                gpv.data = new Float32Array(size);
                gpv.data.fill(NaN);
            }
            //console.log("processGPV--------y=["+y_range[0]+","+y_range[1]+"] x=["+x_range[0]+","+x_range[1]+"] tiled:"+tiled)        
            //console.log(" lat=["+gpv.latBase+"->"+(gpv.latBase-gpv.latInterval*gpv.height)+","+gpv.latInterval+","+gpv.height
            //           +" lon="+gpv.lonBase+"->"+(gpv.lonBase+gpv.lonInterval*gpv.width)+","+gpv.lonInterval+","+gpv.width)        

            var done = [];

            for ( var s = 0 ; s < r.source.length ; s++ ) {
                var source = r.source[s];
                var data_list = source.data_list;
                for ( var i = 0 ; i < data_list.length ; i++ ) {
                    var data_desc = data_list[i];
                    if ( done.indexOf(data_desc.key) >= 0 )
                        continue;
                    done.push(data_desc.key)
                    var data = arrayed?gpv.data[data_desc.index]:gpv.data;
                    // dataの出力GPVにおけるオフセット 
                    var oy = (data_desc.y - y_range[0]);
                    var ox = (data_desc.x - x_range[0]);
                    var data_step = data_desc.data_step;
                    var frac = data_desc.width&1;
                    var width = data_desc.width-frac;
                    var row_num = width/data_step+frac;
                    for ( var y = sy ; y < data_desc.height ; y+=step ) {
                        var gy = (oy+y)/step;
                        if ( gy < 0 )
                            continue;
                        if ( gy >= h )
                            break;
                        for ( var x = sx ; x < data_desc.width ; x+=step ) {
                            var gx = (ox+x)/step;
                            if ( r.wrap_around && gx < 0 )
                                gx += wrap_sample;
                            if ( gx < 0 )
                                continue;
                            if ( gx >= w )
                                continue;
                            var si = y/data_step*row_num+x/data_step;
                            var di = gy*w+gx;
                            data[di] = data_desc.data[si]; 
                        }
                    }
                }
            }
        }
/*
        var nan_count = 0;
        var total = 0;
        for ( var i = 0 ; i < size ; i++ ) {
            if ( isNaN(gpv.data[i]) || gpv.data[i] > 9000)
                nan_count++;
            else
                total += gpv.data[i];
        }
        console.log("gpv count="+size+" NaN="+nan_count+ " Ave="+(total/size));
*/
        if ( r.option.filter ) {
            var f = r.option.filter.split(' ');
            if ( f[0] == 'missing' ) {
                var filter = WRAP.Data.Controller.MissingFilter.filter;
                if ( filter ) {
                    var depth = 1;
                    var d = parseInt(f[1]);
                    if ( !isNaN(d) )
                        depth = d;
                    while ( depth-- ) {
                        var filtered = filter(gpv.data, gpv.width, gpv.height);
                        if ( filtered )
                            gpv.data = filtered;
                        else   
                            break;
                    }
                }
            }
        }

        if ( Object.keys(error_gpv).length ) {
            if ( r.error ) {
                for ( var key in error_gpv )
                    r.error(error_gpv[key]);
            }
            gpv.error = error_gpv;
        }
        updateProgress(r);
        if ( r.success )
            r.success(gpv);
        var index = request.indexOf(r);
        if ( index >=0 )
            request.splice(index, 1);
        return gpv;
    }    

    function update(data) {
        if ( !data.control.state.region.retained )
            return;
        if ( !data.control.state.level.retained )
            return;
        if ( !data.control.state.element.retained )
            return;
        if ( !data.control.state.timelist.retained )
            return;
        data.control.state.timelist.error = null;
        data.control.state.timelist.revision++;
        data._update('timelist', data.control.state.timelist);
        var ds = data.source;
        data._inspector(ds.timelist);
        for ( var i = 0 ; i < ds.timelist.inspector.completed.length ; i++ )
            ds.timelist.inspector.completed[i](data.retained.timelist);
        ds.timelist.autoUpdate();            
    }

    function loadTimelist(data, basetime, index, completed) {
        var timelist = data.control.timelist[index];
        var ds = data.source;
        ds.validtime.load({data:data.control.option.data, basetime:basetime}, false,
            function(vt, urls) {
                if ( !checkError(vt, urls) ) {
                    timelist.validtime = [];
                    for ( var i = 0 ; i < vt.valid_times?.length ; i++ ) {
                        var validtime = wrapTime(vt.valid_times[i]);
                        timelist.validtime[vt.valid_times.length-1-i] = validtime;
                    }
                }
                completed(vt, urls);
            },
            function() {
                completed();
            }
        );
    }

    //function expoTime(t) {
    //    var time = t.substr(0,4)+"-"+t.substr(4,2)+"-"+t.substr(6,5)+":"+t.substr(11,2)+":"+t.substr(13,2)+"+00:00";
    //    return time;
    //}

    function wrapTime(t) {
        var time = t.replace(/:/g,'').replace(/-/g,'').substr(0, 15)
        return time;
    }

    function updateProgress(req) {
        if ( !req.progress )
            return;
        var source = req.source;
        var total = 0;
        var current = 0;
        for ( var i = 0 ; i < source.length ; i++ ) {
            var s = source[i];
            for ( var j = 0 ; j < s.data_list.length ; j++ ) {
                total++;
                if ( s.data_list[j].data )
                    current++;
            }
        }
        req.progress(current, total);
    }

    return {
        init: function(data) {
            data.control.state = {};
            data.control.option = {data:data.controller_conf.data}
            data.control.timelist = null;
            data.control.element = {};
        },

        setup: function(data) {
            var ds = data.source;
            if ( ds.basetime ) {
                if ( ds.basetime.conf.cache ) {
                    if ( ds.basetime.conf.cache_busting === true
                        || !ds.basetime.conf.cache_busting )
                        ds.basetime.conf.cache_busting = 'YYYYMMDDhhmm';
                }
            }
            for ( var key in ds ) {
                data.control.state[key] = {
                    retained:null,
                    error:null,
                    revision:0
                }
            }

            ds.region.load(data.control.option, false, function(res, urls) {
                if ( !checkError(res, urls) ) {
                    data.control.state.region.retained = res;
                    ds.data.conf.Grid = {
                        Width: res.GRID_WE,
                        Height: res.GRID_NS,
                        LatBase: res.NLAT,
                        LonBase: res.WLON,
                        LatInterval: (res.NLAT-res.SLAT)/(res.GRID_NS-1),
                        LonInterval: (res.ELON-res.WLON)/(res.GRID_WE-1)
                    }
                    if ( Math.abs(res.ELON-res.WLON)>359 )
                        ds.data.conf.Grid.LonInterval = 360/res.GRID_WE;
                    if ( data.controller_conf.tile_size )
                        ds.data.conf.Grid.TileSize = parseInt(data.controller_conf.tile_size);
                    update(data);
                }
            });
            ds.level.load(data.control.option, false, function(res, urls) {
                if ( !checkError(res, urls) ) {
                    data.control.state.level.retained = res;
                    update(data);
                }
            });
            ds.element.load(data.control.option, false, function(res, urls) {
                if ( !checkError(res, urls) ) {
                    data.control.state.element.retained = res;
                    if ( Array.isArray(res) ) {
                        for ( var i = 0 ; i < res.length ; i++ ) {
                            var e = res[i];
                            for ( var key in e ) {
                                data.control.element[key] = e[key];
                                break;
                            }
                        }
                    }
                    update(data);
                }
            });
        },

        derive: function(data, id, option, force, completed/*, error, progress*/) {
            var ds = data.source;
            if ( id == 'timelist' ) {
                if ( option && option.basetime && data.control.state.timelist.retained ) {
                    var timelist = data.control.state.timelist.retained.timelist;
                    if ( timelist ) {
                        for ( var index = 0 ; index < timelist.length ; index++ ) {
                            if ( timelist[index].basetime == option.basetime ) {
                                if ( !force && timelist[index].validtime ) {
                                    if ( completed )
                                        completed(data.control.state.timelist.retained);
                                }
                                else {
                                    loadTimelist(data, option.basetime, index, function() {
                                        data.control.state.timelist.retained = {timelist:data.control.timelist};
                                        update(data);
                                        if ( completed )
                                            completed(data.control.state.timelist.retained);
                                    });
                                }
                                return;
                            }
                        }
                    }
                }
                else {
                    ds.basetime.load(data.control.option, false, function(bt, urls) {
                        if ( !checkError(bt, urls) ) {
                            var save = data.control.state.timelist.retained;
                            data.control.state.timelist.retained = null;
                            data.control.state.basetime.retained = bt;
                            var timelist = data.control.timelist = [];

                            // validtime, update_time比較に使用するbasetimeを決める
                            // 最新のbasetimeから設定時間づつ過去方向のbasetimeを探して、見つかった最初のbasetimeを比較対象とする
                            var checkTargetIndex = 1;
                            var loadCnt = 1;
                            if (ds.basetime.conf.time_to_target_for_comparison) {
                                var tempTimeList = bt.map(t => new Date(t).getTime()).sort().reverse();
                                var latestTime = tempTimeList[0];
                                var oldestTime = tempTimeList[tempTimeList.length - 1];
                                while (oldestTime < latestTime) {
                                    latestTime -= ds.basetime.conf.time_to_target_for_comparison * 60 * 60 * 1000;
                                    for (var i = 1; i < tempTimeList.length; i++) {
                                        if (tempTimeList[i] === latestTime) {
                                            checkTargetIndex = i;
                                            latestTime = -1;
                                            break;
                                        }
                                    }
                                }
                            }

                            var validtimes;
                            if (ds.basetime.conf.validtimes) {
                                // 最新のBasetimeが弾かれた場合に設定値-1のbase, validが取れた状態になるため1valid余分に取得する
                                validtimes = ds.basetime.conf.validtimes + 1;
                            } else {
                                validtimes = bt.length;
                            }

                            if ( validtimes > bt.length )
                                validtimes = bt.length;

                            // チェック対象のbasetimeが取得対象に入っている場合はロード完了監視用のカウンターから削る
                            if (checkTargetIndex < validtimes) {
                                loadCnt--;
                            }

                            var loaded = 0;
                            loadCnt += validtimes;
                            if (loadCnt > bt.length) {
                                loadCnt = bt.length;
                            }
                            for ( var i = 0 ; i < bt.length ; i++ ) {
                                var index = bt.length-1-i;
                                var basetime = wrapTime(bt[i]);
                                timelist[index] = {basetime:basetime};
                                if ( index < validtimes || index === checkTargetIndex) {
                                    loadTimelist(data, bt[i], index,
                                        function(ret, urls) {
                                            if ( ++loaded == loadCnt ) {
                                                var dataUpdate = function() {
                                                    data.control.state.timelist.retained = {timelist:data.control.timelist};
                                                    update(data);
                                                    if ( completed )
                                                        completed(data.control.state.timelist.retained);
                                                }

                                                var checkExpoData = function() {
                                                    var elements = [];
                                                    for (var i = 0; i < data.source.element.data.retained.element.length; i++) {
                                                        var element = data.source.element.data.retained.element[i];
                                                        elements = elements.concat(Object.keys(element));
                                                    }
                                                    var option = {
                                                        element: JSON.stringify(elements),
                                                        level: JSON.stringify(data.source.level.data.retained.level),
                                                        basetime: latestData.basetime,
                                                        validtime: JSON.stringify(latestData.validtime)
                                                    };
                                                    data.source.updatetime.load(option, false, function(latestUpdateTime) {
                                                        option.basetime = comparisonData.basetime;
                                                        option.validtime = JSON.stringify(comparisonData.validtime);
                                                        data.source.updatetime.load(option, false, function(prevUpdateTime) {
                                                            var countLoadedData = function(data) {
                                                                var ret = {};
                                                                var keys = Object.keys(data);
                                                                for(var i = 0; i < keys.length; i++) {
                                                                    var key = keys[i];
                                                                    ret[key] = 0;
                                                                    var elemData = data[key];
                                                                    for(var j = 0; j < elemData.length; j++) {
                                                                        if(elemData[j] !== "") {
                                                                            ret[key]++;
                                                                        }
                                                                    }
                                                                }
                                                                return ret;
                                                            }
                                                            var latestLoadedCount = countLoadedData(latestUpdateTime);
                                                            var prevLoadedCount = countLoadedData(prevUpdateTime);
                                                            var keys = Object.keys(prevLoadedCount);
                                                            for(var i = 0; i < keys.length; i++) {
                                                                var key = keys[i];
                                                                if(latestLoadedCount[key] < prevLoadedCount[key]) {
                                                                    data.control.timelist.shift();
                                                                    Cache.remove(urls[0]);
                                                                    break;
                                                                }
                                                            }
                                                            dataUpdate();
                                                        });
                                                    });
                                                }

                                                var latestData = data.control.timelist[0];
                                                var comparisonData = data.control.timelist[1];
                                                if (checkTargetIndex) {
                                                    comparisonData = data.control.timelist[checkTargetIndex];
                                                }
                                                // validtimeが取得できない場合はデータのチェックを行わない
                                                if(!latestData.validtime || !comparisonData.validtime) {
                                                    dataUpdate();
                                                }
                                                // 最新のvalidtimeの件数が一つ前のvalidtimeの件数より少なければ
                                                // Expo側のデータが揃ってないと判断し、最新のデータを捨てる
                                                else if(latestData.validtime.length < comparisonData.validtime.length) {
                                                    data.control.timelist.shift();
                                                    Cache.remove(urls[0]);
                                                    dataUpdate();
                                                } else if(data.source.updatetime !== undefined) {
                                                    // 最新のbasetimeと一つ前のbasetimeに紐づくvalidtimeのExpo側の
                                                    // データが揃っているかチェックする
                                                    var retryCounter = 0;
                                                    if(data.source.element.data.retained.element && data.source.level.data.retained.level) {
                                                        checkExpoData();
                                                    } else {
                                                        var id = setInterval(function() {
                                                            if(data.source.element.data.retained.element && data.source.level.data.retained.level) {
                                                                clearInterval(id);
                                                                checkExpoData();
                                                            }
                                                            if(2 < retryCounter) {
                                                                clearInterval(id);
                                                            }
                                                            retryCounter++;
                                                        }, 1000);
                                                    }
                                                } else {
                                                    dataUpdate();
                                                }
                                            }
                                        },
                                        function() {
                                            if ( ++loaded == validtimes ) {
                                                data.control.state.timelist.retained = {timelist:data.control.timelist};
                                                update(data);
                                                if ( completed )
                                                    completed(data.control.state.timelist.retained);
                                            }
                                    });
                                }
                                else if ( save && save.timelist ) {
                                    for ( var j = 0 ; j < save.timelist.length ; j++ ) {
                                        if ( save.timelist[j].basetime == basetime ) {
                                            if ( save.timelist[j].validtime )
                                                timelist[index].validtime = save.timelist[j].validtime;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    });
                }       
            }
        },

        override: function(data, id, option) {
            if ( !option )
                option = {};
            if ( !option.data && data.control && data.control.option )
                option.data = data.control.option.data;
            return option;
        },

        getTileValue: function(data, id, tile, option, sampling, success, error, progress, key) {
//console.log("EXPO_NumericalDB getTileValue");
            var ds = data.source[id];
            var result = [];
            var tile_request = [];
            var error_tile = {};
            for ( var i = 0 ; i < tile.length ; i++ ) {
                var t = tile[i];
                var tile_id = t.id;
                var tile_key = makeTileKey(ds, option, tile_id, sampling);
                if ( (result[i] = getCache(tile_key)) ) {
                    var e = getError(tile_key);
                    if ( e )
                        error_tile[tile_key] = e;
                    continue;
                }
                tile_request[i] = {
                    key:tile_key,
                    tile:t
                };
            }
            if ( !tile_request.length && success ) {
                if ( error ) {
                    for ( var key in error_tile )
                        error(error_tile[key]);
                }
                success(result);
                return;
            }

            var z = Math.round(tile[0].z);
            var precision = (!ds.conf.Grid||ds.conf.Grid.TileSize)?360/(256*Math.pow(2,z)):0;
            var grid_sampling = "decimation " + precision;
            var grid_bounds = [];
            for ( var i = 0 ; i < tile_request.length ; i++ ) {
                var t = tile[i];
                if ( t ) {
                    grid_bounds.push({
                        north:t.bounds.north/60,
                        south:t.bounds.south/60,
                        west:t.bounds.west/60,
                        east:t.bounds.east/60
                    });
                }
            }

            this.getGridValue(data, id, grid_bounds, option, grid_sampling,
                function(gpv) {
                    for ( var i = 0 ; i < tile_request.length ; i++ ) {
                        var t = tile_request[i];
                        if ( !t )
                            continue;
                        var result_tile = result[i] = WRAP.GPV.getTile(gpv, t.tile.cood, sampling);
                        setCache(t.key, result_tile, tile_data_size, ds, gpv.error);
                    }
                    if ( success )
                        success(result);
                },
                error, progress, key);
        },

        getGridValue: function(data, id, bounds, option, sampling, success, error, progress, key) {
//console.log("EXPO_NumericalDB getGridValue");
            if ( !option || !option.validtime )
                return;
            var region = data.control.state.region.retained;
            if ( !region )
                return;

            var ds = data.source[id];

            var req = {
                key:key,
                array:Array.isArray(bounds)?bounds.length:0,
                option:option,
                element:option.element,
                source:[]
            }
            if ( !req.array )
                bounds = [bounds];
            req.source.length = bounds.length;

            var grid = ds.conf.Grid;
            var tiled = grid.TileSize;
            var wrap_around = (grid.LonInterval*grid.Width >= 359.0);
            var lonBase = grid.LonBase;
            var lonEnd = grid.LonBase+grid.LonInterval*grid.Width;
            if ( lonBase < 180 && 180 < lonEnd )
                wrap_around = true;
            if ( lonBase < 360 && 360 < lonEnd )
                wrap_around = true;
            var sampling_method, sampling_precision = 0;
            if ( sampling ) {
                var s = sampling.split(' ');
                sampling_method = s[0];
                if ( s[1] )
                    sampling_precision = parseFloat(s[1]);
            }
            var wait = [];

            var tz = 0;
            var min_tz = 0;
            var min_lond = grid.LonInterval;
            if ( ds.conf.min_precision ) {
                while ( min_lond < ds.conf.min_precision ) {
                    min_lond *= 2;
                    min_tz++;
                }
            }
            var lond = grid.LonInterval;
            while ( lond < sampling_precision ) {
                lond *= 2;
                tz++;
            }
            if ( tz < min_tz )
                tz = min_tz;
            var step = Math.pow(2,tz);

            if ( tiled ) {
                    var max_zoom = maxTileZoom(grid);
                if ( tz > max_zoom )
                    tz = max_zoom;
            }
            var data_step = Math.pow(2,tz);
            req.grid = grid;
            req.wrap_around = wrap_around;
            req.step = step;

            for ( var s = 0 ; s < req.source.length ; s++ ) {
                var b = bounds[s];
                var source = req.source[s] = {
                    ds:ds,
                    grid:grid,
                    tiled:tiled,
                    option:option,
                    bounds:b,
                    sampling_method:sampling_method,
                    sampling_precision:sampling_precision,
                    data_list:[]
                };
                if ( tiled ) {
                    var max_zoom = maxTileZoom(grid);
                    //console.log("loadGPV2 "+JSON.stringify(content));            
                    var latBase = grid.LatBase;
                    var lonBase = grid.LonBase;
                    var latInterval = grid.LatInterval; 
                    var lonInterval = grid.LonInterval;

                    // margin for interpolation
                    var gsy = Math.floor((latBase-b.north)/latInterval);
                    var gey = Math.ceil((latBase-b.south)/latInterval)+1;
                    var gsx = Math.floor((b.west-lonBase)/lonInterval);
                    var gex = Math.ceil((b.east-lonBase)/lonInterval)+1;
                    if ( step == 1 ) {
                        gsy -= 1;
                        gsx -= 1;
                    }
                    if ( gsy < 0 )
                        gsy = 0;
                    if ( wrap_around ) {
                        if ( gsx < 0 ) {
                            gsx += grid.Width;
                            gex += grid.Width;
                        }
                    }

                    // GPV範囲に間引きstepを適用
                    gsy = Math.floor(gsy/step)*step;
                    gey = Math.ceil(gey/step)*step;
                    gsx = Math.floor(gsx/step)*step;
                    gex = Math.ceil(gex/step)*step;

                    source.range = {    // オリジナル解像度における対象インデックス範囲
                        sx:gsx,        
                        sy:gsy,
                        ex:gex,
                        ey:gey
                    }

                    //　GPV範囲のタイル範囲
                    var tile_band = Math.pow(2, max_zoom-tz);           // 何枚のタイルで構成されるか
                    var tile_step = step*grid.TileSize;     // 一枚のタイルあたりのオリジナル解像度でのピクセル数
                    var min_tile_x = Math.floor(gsx/tile_step);
                    var max_tile_x = gex<grid.Width?Math.floor(gex/tile_step):tile_band+Math.floor((gex-grid.Width)/tile_step);
                    var min_tile_y = Math.floor(gsy/tile_step);
                    var max_tile_y = Math.floor(gey/tile_step);

                    if ( min_tile_y < 0 )
                        min_tile_y = 0;

                    for ( var y = min_tile_y ; y <= max_tile_y ; y++ ) {
                        var tys = y*tile_step;
                        if ( tys >= grid.Height )
                            break;                        
                        var tye = tys+tile_step;
                        if ( tye >= grid.Height )       // active_height
                            tye = grid.Height;
                        var th = tye-tys;
                        for ( var x = min_tile_x ; x <= max_tile_x ; x++ ) {
                            var xx = x;
                            if ( xx < 0 )
                                xx += tile_band;
                            if ( xx >= tile_band )
                                xx -= tile_band;
                            var txs = xx*tile_step;
                            var txe = txs+tile_step;
                            if ( txe >= grid.Width )    // active_width
                                txe = grid.Width;
                            var tw = txe-txs;
                            if ( tw < 0 || txs < 0 || txe < 0 || txe <= txs )
                                continue;
                            var data_desc = {           //　当該データタイルにおけるオリジナルデータ取得範囲。
                                data_step:data_step,    //  tileに組みまれるstep
                                x:txs,                  //　オリジナルデータでの範囲
                                y:tys,
                                width:Math.floor(tw/data_step)*data_step,  //  オリジナルデータでのサイズ(active_size適用済み)
                                height:Math.floor(th/data_step)*data_step
                            };
                            var opt = {
                                data:data.control.option.data,
                                sx:txs,
                                sy:tys,
                                ex:txe-data_step,
                                ey:tye-data_step,
                                dx:data_step,
                                dy:data_step,
                                z:tz, y:y, x:xx    
                            };
                            addData(wait, source, data_desc, opt);
                        }
                    }
                }
                else {
                    var latBase = grid.LatBase;
                    var lonBase = grid.LonBase;
                    var latInterval = grid.LatInterval; 
                    var lonInterval = grid.LonInterval; 

                    var gsy = Math.floor((latBase-b.north)/latInterval);
                    var gey = Math.ceil((latBase-b.south)/latInterval);
                    var gsx = Math.floor((b.west-lonBase)/lonInterval);
                    var gex = Math.ceil((b.east-lonBase)/lonInterval);

                    if ( wrap_around ) {
                        var wrap_width = Math.round(360/lonInterval);
                        if ( gsx < lonBase ) {
                            gsx += wrap_width;
                            gex += wrap_width;
                        }
                        while ( gsx <= 0 ) {
                            gsx += wrap_width;
                            gex += wrap_width;
                        }
                        while ( gex < 0 ) {
                            gsx += wrap_width;
                            gex += wrap_width;
                        }
                    }

                    if ( gsy > gey ) {
                        var tmp = gsy;
                        gsy = gey;
                        gey = tmp;
                    }
                    if ( step > 1 ) {
                        // GPV範囲に間引きstepを適用
                        gsy = Math.floor(gsy/step)*step;
                        gey = Math.ceil(gey/step)*step;
                        gsx = Math.floor(gsx/step)*step;
                        gex = Math.ceil(gex/step)*step;
                    }

                    // add mergin
                    gsy -= step;
                    gey += step;
                    gsx -= step;
                    gex += step;

                    source.range = {    // オリジナル解像度における対象インデックス範囲
                        sx:gsx,        
                        sy:gsy,
                        ex:gex,
                        ey:gey
                    }

                    var data_desc = {           //　当該データタイルにおけるオリジナルデータ取得範囲。
                        data_step: 1,           //  非tileなのでオリジナル解像度
                        x:0,                    //　オリジナルデータでの範囲
                        y:0,
                        width:grid.Width,       //  オリジナルデータでのサイズ(active_size適用済み)
                        height:grid.Height
                    };

                    var dx = 1;
                    var dy = 1;
                    if(data.conf.data.Attributes && data.conf.data.Attributes.stride) {
                        dx = dy = data.conf.data.Attributes.stride;
                    }
                    var opt = {
                        data:data.control.option.data,
                        sx:0,
                        sy:0,
                        ex:grid.Width-1,
                        ey:grid.Height-1,
                        dx:dx,
                        dy:dy
                    };
        
                    addData(wait, source, data_desc, opt);
                }
            }

            req.success = success;
            req.error = error;
            req.progress = progress;
            request.push(req);
            if ( !wait.length ) {
                processRequest(req);
                return;
            }
            updateProgress(req);
            for ( var i = 0 ; i < wait.length ; i++ )
                load(wait[i]);
        },

        getPointValue: WRAP.Data.Controller.getPointValue,

        cancel: WRAP.Data.Controller.cancel
    }
}());
/* eslint-enable */
